import MapView from '@arcgis/core/views/MapView'
import Map from '@arcgis/core/Map'
import WebMap from '@arcgis/core/WebMap'
import Graphic from '@arcgis/core/Graphic'
import Point from '@arcgis/core/geometry/Point'
import Search from '@arcgis/core/widgets/Search'
import PopupTemplate from '@arcgis/core/PopupTemplate'
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer'
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol'
import { CustomerDto, CustomerType, LocationDto } from '../../../interfaces/IEvent'

export function CreateMap(isDarkTheme: boolean) {
  if (isDarkTheme) {
    return new WebMap({
      basemap: 'dark-gray-3d',
    })
  }
  return new WebMap({
    basemap: 'streets-navigation-vector',
  })
}

export function CreateView(map: Map, mapRef: any, isDarkTheme: boolean) {
  const view = new MapView({
    container: mapRef.current,
    center: [10.4662, 61.1153],
    zoom: isDarkTheme ? 4 : 6,
    map: map,
  })

  // const mapImageLayer = [
  //     new MapImageLayer({
  //         portalItem: {
  //             id: "cd1d5d314e204ff79e127882194795c6",
  //             portal: {
  //                 url: portalUrl
  //             }
  //         }
  //     }),
  //     new MapImageLayer({
  //         portalItem: {
  //             id: "cd1d5d314e204ff79e127882194795c6",
  //             portal: {
  //                 url: portalUrl
  //             },
  //         }
  //     })
  // ];

  // map.addMany(mapImageLayer, 0);

  // if(isDarkTheme){
  //     const darkVectorTileLayer = new VectorTileLayer({
  //         portalItem: {
  //             id: "bdb9a6268b45459eab7af9a6f5532c5d",
  //             portal: {
  //                 url: portalUrl
  //             }
  //         }
  //     });
  //     map.add(darkVectorTileLayer, 0);
  // } else {
  //     const lightVectorTileLayer = new VectorTileLayer({
  //         portalItem: {
  //             id: "bdb9a6268b45459eab7af9a6f5532c5d",
  //             portal: {
  //                 url: portalUrl
  //             }
  //         }
  //     });
  //     map.add(lightVectorTileLayer, 0);
  // }

  const search = new Search({
    view: view,
  })

  view.ui.add(search, 'top-right')
  return view
}

export function AddPopupTemplate(customer: CustomerDto, location: LocationDto) {
  const setCustomerType = (customerType: string) => {
    if (customerType === CustomerType.Company) {
      return 'Bedriftskunde'
    } else if (customerType === CustomerType.CompanyWithSla) {
      return 'Bedriftskunde med SLA'
    } else if (customerType === CustomerType.Private) {
      return 'Privatkunde'
    } else {
      return 'Ukjent kundetype'
    }
  }

  const popupTemplate = new PopupTemplate({
    title: customer.customerNumber + ' - ' + customer.customerName,
    content: `<b>${setCustomerType(customer.customerType)}</b><br><br>
        <b>Leveransepunkt:</b> ${location.servicePointId}<br><br>
        <b>Adresse:</b> ${location.addressId} - ${location.connectionNumbers?.join(', ') ?? ''}`,
  })

  return popupTemplate
}

export function AddPopupTemplateForLocations(customer: CustomerDto, locations: LocationDto[]) {
  const setCustomerType = (customerType: string) => {
    if (customerType === CustomerType.Company) return 'Bedriftskunde'
    if (customerType === CustomerType.CompanyWithSla) return 'Bedriftskunde med SLA'
    if (customerType === CustomerType.Private) return 'Privatkunde'
    return 'Ukjent kundetype'
  }

  const leveransepunkter = locations.map((l) => l.servicePointId).join('<br>')
  const adresser = locations.map((l) => `${l.addressId} - ${l.connectionNumbers?.join(', ') ?? ''}`).join('<br>')

  const popupTemplate = new PopupTemplate({
    title: customer.customerNumber + ' - ' + customer.customerName,
    content: `<b>${setCustomerType(customer.customerType)}</b><br><br>
        <b>Leveransepunkt:</b><br/>${leveransepunkter}<br><br>
        <b>Adresser:</b><br/>${adresser}`,
  })

  return popupTemplate
}

export function AddPoint(graphicsLayer: GraphicsLayer, popupTemplate: PopupTemplate, coordinate: LocationDto) {
  if (coordinate.gisApiLocation && coordinate.gisApiLocation?.x !== 0 && coordinate.gisApiLocation?.y !== 0) {
    const point = new Point({
      longitude: coordinate.gisApiLocation.x,
      latitude: coordinate.gisApiLocation.y,
      spatialReference: {
        wkid: coordinate.gisApiLocation.srid,
      },
    })

    const simpleMarkerSymbol = new SimpleMarkerSymbol({
      color: 'blue',
      outline: {
        color: [255, 255, 255],
        width: 1,
      },
    })

    const pointGraphic = new Graphic({
      geometry: point,
      symbol: simpleMarkerSymbol,

      popupTemplate: popupTemplate,
    })

    graphicsLayer.add(pointGraphic)
  }
}
